import React, { useEffect, useRef } from "react";
import "./payment.css";

const Address = ({
  fullname,
  setFullname,
  phoneNumber,
  setPhoneNumber,
  city,
  address,
  setAddress,
  handleConfirm,
  handleEdit,
  isConfirmed,
  cityDataBoolean,
  handleAddressCityChangeString,
  isConfirmedPaymentForm,
}) => {
  const cityFocusRef = useRef();
  const addressFocusRef = useRef();
  const fullnameFocusRef = useRef();

  //! Ensuring that only numbers are entered into the input
  const handlePhoneNumberChange = (e) => {
    let input = e.target.value;
    // Remove any non-numeric characters
    input = input.replace(/[^0-9]/g, "");

    // Remove any leading 0's
    while (input.length > 0 && input.charAt(0) === "0") {
      input = input.substring(1);
    }

    // Limit the input to 10 digits
    input = input.substring(0, 10);

    // Add spaces between groups of digits
    let formattedInput = "";
    for (let i = 0; i < input.length; i++) {
      if (i === 0) {
        formattedInput += "0(";
      } else if (i === 3) {
        formattedInput += ") ";
      } else if (i === 6) {
        formattedInput += " ";
      }
      formattedInput += input.charAt(i);
    }

    if (formattedInput.length === 15) {
      cityFocusRef.current.focus();
    }

    setPhoneNumber(formattedInput);
  };

  //! Ensuring that only strings are entered into the input
  const handleAddressFullnameChangeString = (event) => {
    const { value } = event.target;
    // Gelen değer içinde sadece harf karakterleri olup olmadığını kontrol ediyoruz
    const onlyLetters = /^[A-Za-zğüşıöçĞÜŞİÖÇ\s]+$/;
    if (value === "" || onlyLetters.test(value)) {
      setFullname(value);
    }
  };

  //! If the entered city is correct -
  //! focus on the next input.
  useEffect(() => {
    if (cityDataBoolean) {
      addressFocusRef.current.focus();
    }
  }, [cityDataBoolean]);

  //! If the Payment Form is filled -
  //! focus on the Address Form Fullname input.
  useEffect(() => {
    if (isConfirmedPaymentForm && !isConfirmed) {
      fullnameFocusRef.current.focus();
    }
  }, [isConfirmedPaymentForm]);

  return (
    <div className="address-form w-100">
      {isConfirmed && (
        <div className="isConfirm animate__animated animate__fadeIn">
          <div className="isConfirm-icon">
            <i className="fas fa-solid fa-circle-check"></i>
          </div>
        </div>
      )}

      <h6 className="address-form-title">Delivery Location</h6>
      <form className="form">
        <div className="credit-card-info--form">
          <div className="input_container">
            <label htmlFor="password_field" className="input_label">
              Full Name
            </label>
            <input
              className="input_field text-capitalize"
              type="text"
              name="input-name"
              placeholder="ENTER YOUR FULL NAME"
              value={fullname}
              onChange={handleAddressFullnameChangeString}
              ref={fullnameFocusRef}
            />
          </div>
          <div className="input_container">
            <label htmlFor="password_field" className="input_label">
              Phone Number
            </label>
            <input
              className="input_field"
              type="text"
              name="phoneNumber"
              placeholder="0 (___) ___ ____"
              value={phoneNumber}
              onChange={handlePhoneNumberChange}
              maxLength={15}
            />
          </div>
          <div className="input_container">
            <label htmlFor="password_field" className="input_label">
              City
            </label>
            <input
              className="input_field city"
              type="text"
              name="input-name"
              placeholder="ISTANBUL"
              value={city}
              ref={cityFocusRef}
              onChange={handleAddressCityChangeString}
            />
          </div>
          <div className="input_container">
            <label htmlFor="password_field" className="input_label">
              Address
            </label>
            <textarea
              className="textarea_field text-capitalize"
              placeholder="KOSUYOLU CAD. FIDAN SK. NO:99/C KADIKOY"
              value={address}
              ref={addressFocusRef}
              onChange={(e) => setAddress(e.target.value)}
            />
          </div>
          {isConfirmed ? (
            <button onClick={handleEdit} className="purchase--btn">
              EDIT
            </button>
          ) : (
            <button onClick={handleConfirm} className="purchase--btn">
              CONFIRM
            </button>
          )}
        </div>
      </form>
    </div>
  );
};

export default Address;
